import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import AddIcon from '@mui/icons-material/Add';
import '../styles/AbsencePersonnel.css';
import AbsencePersonnelService from '../services/absencePersonnelService';
import PersonnelService from '../services/personnelService';
import { useNavigate, Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// PAGINATION
const ITEMS_PER_PAGE = 5;

function AbsencePersonnel() {
  const [absences, setAbsences] = useState([]);
  const [personnels, setPersonnels] = useState([]);
  const [currentAbsence, setCurrentAbsence] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [statutAbsence, setStatutAbsence] = useState(null);

  const handleStatutChange = (event) => {
    setStatutAbsence(Number(event.target.value));
  };

  // Détermine le nombre de jours dans le mois actuel
  const currentMonth = selectedDate.getMonth();
  const currentYear = selectedDate.getFullYear();
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

  // Récupère les données de la base de données
  const fetchData = () => {
    AbsencePersonnelService.all()
      .then(result => {
        if (result.success) {
          setAbsences(result.data['data']);
          console.log("liste data : ", result.data['data']);
        }
      })
      .catch(error => alert(error.error));

    PersonnelService.all()
      .then(result => {
        if (result.success) {
          setPersonnels(result.data);
        }
      })
      .catch(error => alert(error.error));
  };

  useEffect(() => {
    fetchData();
  }, [selectedDate]); // Reload data when the date changes

  // Modal pour modifier une absence
  const [openEditModal, setOpenEditModal] = useState(false);
  const handleCloseEditModal = () => setOpenEditModal(false);
  const handleOpenEditModal = (absence) => {
    setCurrentAbsence(absence);
    setOpenEditModal(true);
  };

  // Modal pour supprimer une absence
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  const handleOpenDeleteModal = () => {
    setOpenDeleteModal(true);
  };



  // Modal pour ajouter une absence
  const [openAddModal, setOpenAddModal] = useState(false);
  const handleOpenAddModal = () => setOpenAddModal(true);
  const handleCloseAddModal = () => setOpenAddModal(false);

  // Ajouter une absence
  const handleAddAbsence = async (event) => {
    event.preventDefault();
    const form = event.target;
    const lieu = form.id_statut_absence.value === '3' ? form.lieu.value : '-';

    const newAbsence = {
      debut: form.debut.value,
      fin: form.fin.value,
      id_personnel: form.id_personnel.value,
      id_statut_absence: form.id_statut_absence.value,
      lieu: lieu
    };
    const result = await AbsencePersonnelService.add(newAbsence);
    if (result.success) {
      setStatutAbsence('');
      fetchData();
      handleCloseAddModal();
    } else {
      alert(result.error);
    }
  };

  // Mettre à jour une absence
  const handleUpdateAbsence = async (event) => {
    event.preventDefault();
    const form = event.target;
    const lieu = form.id_statut_absence.value === '3' ? form.lieu.value : '-';

    const updatedAbsence = {
      debut: form.debut.value,
      fin: form.fin.value,
      id_personnel: form.id_personnel.value,
      id_statut_absence: form.id_statut_absence.value,
      lieu: lieu

    };
    console.log(updatedAbsence)
    const result = await AbsencePersonnelService.update(currentAbsence.id, updatedAbsence);
    if (result.success) {
      console.log(currentAbsence);
      fetchData();
      handleCloseEditModal();
    } else {
      alert(result.error);
    }
  };

  // Supprimer une absence
  const handleDeleteAbsence = async () => {
    try {
      await AbsencePersonnelService.delete(currentAbsence.id);
      fetchData();
      handleCloseDeleteModal();
    } catch (error) {
      alert('Erreur lors de la suppression de l\'absence.');
    }
  };



  // Fonction pour obtenir la couleur de l'absence
  const getAbsenceColor = (type) => {
    switch (type) {
      case 1: return 'rgb(31 183 253)'; // Congé
      case 2: return 'red';  // Maladie
      case 3: return '#78f978'; // Mission
      default: return 'transparent';
    }
  };

  // Fonction pour vérifier si une date est comprise entre le début et la fin d'une absence
  const isAbsentOnDay = (absence, day) => {
    const debut = new Date(absence.date_debut);
    var Newdate = new Date(absence.date_fin);
    const fin = new Date(Newdate.setDate(Newdate.getDate() + 1));
    const date = new Date(currentYear, currentMonth, day);
    return date >= debut && date <= fin;
  };

  // Gestion de la navigation entre les mois
  const handlePreviousMonth = () => {
    setSelectedDate(new Date(currentYear, currentMonth - 1, 1));
  };

  const handleNextMonth = () => {
    setSelectedDate(new Date(currentYear, currentMonth + 1, 1));
  };

  const handleDateChange = (event) => {
    setSelectedDate(new Date(event.target.value));
  };

  //Filtrer les personnels ayant des absences dans le mois actuel


  const filterPersonnelByAbsences = (personnels, absences) => {
    const personnelWithAbsences = personnels.filter(person =>
      absences.some(absence =>
        absence.id_personnel === person.id 
      )
    );
    return personnelWithAbsences;
  };

  // const filterPersonnelByAbsences = (personnels, absences) => {
  //   return personnels.map(personnel => ({
  //     ...personnel,
  //     hasAbsence: absences.some(absence =>
  //       absence.id_personnel === personnel.id &&
  //       new Date(absence.date_debut).getMonth() === currentMonth &&
  //       new Date(absence.date_fin).getMonth() === currentMonth
  //     )
  //   }));
  // };


  const filteredPersonnels = filterPersonnelByAbsences(personnels, absences);

  const isWeekend = (day) => {
    const date = new Date(currentYear, currentMonth, day);
    const dayOfWeek = date.getDay();
    return dayOfWeek === 0 || dayOfWeek === 6; // Sunday or Saturday
  };

  return (
    <div className="reunion-container">
      <div>
        <Link style={{ color: 'black', textDecoration: 'none', backgroundColor: 'white', borderRadius: '5px', padding: '5px 10px' }} to={"/"}> <ArrowBackIcon fontSize='12px' /> retour</Link>
      </div>
      <center>
        <div className="titre-page">
          ABSENCE PERSONNEL
        </div>
        <div className='date-info'>
          <button onClick={handlePreviousMonth}>Précédent</button>
          <span>{selectedDate.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}</span>
          <button onClick={handleNextMonth}>Suivant</button>
          <input
            type="date"
            value={selectedDate.toISOString().substring(0, 10)}
            onChange={handleDateChange}
          />
        </div>
        <div className="legende-container">
          <div className="legende-item">
            <span className="color-point" style={{ backgroundColor: 'red' }}></span>
            <span>Maladie</span>
          </div>
          <div className="legende-item">
            <span className="color-point" style={{ backgroundColor: 'rgb(31 183 253)' }}></span>
            <span>Congé</span>
          </div>
          <div className="legende-item">
            <span className="color-point" style={{ backgroundColor: '#78f978' }}></span>
            <span>Mission</span>
          </div>
        </div>
      </center>


      <hr />
      <div className='ajouter-btn' onClick={handleOpenAddModal}>
        <AddIcon fontSize='small' />
      </div>

      <table className="reunion-table" style={{ width: '100%', overflowX: 'scroll' }}>
        <thead>
          <tr>
            <th></th>
            {Array.from({ length: daysInMonth }, (_, index) => {
              const day = index + 1;
              const dayOfWeek = new Date(currentYear, currentMonth, day).toLocaleDateString('fr-FR', { weekday: 'narrow' });
              const weekDays = {
                'L': 'Lun',
                'M': 'Mar',
                'M': 'Mer',
                'J': 'Jeu',
                'V': 'Ven',
                'S': 'Sam',
                'D': 'Dim'
              };

              return (
                <th
                  key={index}
                  style={{ color: 'white', backgroundColor: isWeekend(day) ? 'rgb(167 167 167)' : 'inherit', border: isWeekend(day) ? 'solid 1px rgb(167 167 167)' : '' }}
                >
                  {weekDays[dayOfWeek] || day}
                </th>
              );
            })}
          </tr>
          <tr>
            <th>Personnel</th>
            {Array.from({ length: daysInMonth }, (_, index) => {
              const day = index + 1;
              return (
                <th
                  key={index}
                  style={{ color: 'white', backgroundColor: isWeekend(day) ? 'rgb(167 167 167)' : 'inherit', border: isWeekend(day) ? 'solid 1px rgb(167 167 167)' : '' }}
                >
                  {day}
                </th>
              );
            })}
          </tr>


        </thead>

        <tbody>
          {console.log("personnels : ", filteredPersonnels)}
          {filteredPersonnels.map((person, index) => (
            <tr key={index} >
              <td style={{ textAlign: 'left' }}>
                <span style={{ color: '#E6C795', fontWeight: 'bold' }}>{person.code} : </span>
                {person.first_name} {person.last_name}
                {absences.some(absence => absence.id_personnel === person.id) && (
                  <span style={{ fontStyle: 'italic', marginLeft: '10px', color: '#78f978' }}>
                    {absences.find(absence => absence.id_personnel === person.id)?.lieu}
                  </span>
                )}
              </td>
              {Array.from({ length: daysInMonth }, (_, dayIndex) => {
                const day = dayIndex + 1;
                const absenceForDay = absences.find(absence =>
                  absence.id_personnel === person.id &&
                  isAbsentOnDay(absence, day + 1)
                );
                const isWeekendDay = isWeekend(day);

                // Default cell style
                let cellStyle = {
                  backgroundColor: isWeekendDay ? 'rgb(167 167 167)' : 'inherit',
                  color: isWeekendDay ? 'gray' : 'inherit',
                  border: isWeekendDay ? 'solid 1px rgb(167 167 167)' : ''
                };

                // If there is an absence, override the cell color
                if (absenceForDay && !isWeekendDay) {
                  cellStyle = {
                    ...cellStyle,
                    backgroundColor: getAbsenceColor(absenceForDay.id_statut_absence),
                    border: getAbsenceColor(absenceForDay.id_statut_absence),
                    borderBottom: 'solid 1px gray',
                  };
                }

                return (
                  <td
                    key={dayIndex}
                    style={cellStyle}
                    onClick={() => {
                      if (absenceForDay) {
                        handleOpenEditModal(absenceForDay);
                      }
                    }}
                  />
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>



      <Modal
        open={openEditModal}
        onClose={handleCloseEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ maxWidth: 700, margin: 'auto', padding: 2 }}>
          <form id="editForm" onSubmit={handleUpdateAbsence}>
            <div className='titre-form'>
              <span>Modifier Absence Personnel</span>

            </div>
            <div className="form-group">
              <label htmlFor="debut">Date Début</label>
              <input
                type="date"
                name="debut"
                id="debut"
                defaultValue={currentAbsence?.date_debut}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="fin">Date Fin</label>
              <input
                type="date"
                name="fin"
                id="fin"
                defaultValue={currentAbsence?.date_fin}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="id_personnel">ID Personnel</label>
              <select
                name="id_personnel"
                id="id_personnel"
                defaultValue={currentAbsence?.id_personnel}
                required
              >
                {personnels.map((person, index) =>
                  <option key={index} value={person.id}>{person.code}</option>
                )}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="id_statut_absence">Statut Absence</label>
              <select
                name="id_statut_absence"
                id="id_statut_absence"
                defaultValue={currentAbsence?.id_statut_absence}
                required
              >
                <option value={1}>Congé</option>
                <option value={2}>Maladie</option>
                <option value={3}>Mission</option>
              </select>
            </div>

            {currentAbsence?.id_statut_absence === 3 && (
              <div className="form-group">
                <label htmlFor="lieu">Lieu</label>
                <input type="text" name="lieu" id="lieu" />
              </div>
            )}

            <div className="btn-container">
              <button type="submit">Modifier</button>
            </div>
          </form>

          <div className="btn-container" style={{ width: '100%', backgroundColor: 'white', padding: '5px', borderRadius: '5px' }}>
            <button onClick={handleOpenDeleteModal}
              style={{ cursor: 'pointer', float: 'right', backgroundColor: 'red' }}>
              supprimer l'absence
            </button>
          </div>
        </Box>
      </Modal>


      <Modal
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ maxWidth: 500, margin: 'auto', padding: 2 }}>
          <div className="modal-content">
            <p>Êtes-vous sûr de vouloir supprimer cette absence ?</p>
            <div className="modal-buttons">
              <button className="btn btn-danger" onClick={handleDeleteAbsence}>Supprimer</button>
              <button className="btn btn-secondary" onClick={handleCloseDeleteModal}>Annuler</button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openAddModal}
        onClose={handleCloseAddModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ maxWidth: 700, margin: 'auto', padding: 2 }}>
          <form id="addForm" onSubmit={handleAddAbsence}>
            <div className='titre-form'>
              <span>Ajouter Absence Personnel</span>
            </div>
            <div className="form-group">
              <label htmlFor="debut">Date Début</label>
              <input type="date" name="debut" id="debut" required />
            </div>
            <div className="form-group">
              <label htmlFor="fin">Date Fin</label>
              <input type="date" name="fin" id="fin" required />
            </div>

            <div className="form-group">
              <label htmlFor="id_personnel">ID Personnel</label>
              <select name="id_personnel" id="id_personnel" required>
                {personnels.map((person, index) =>
                  <option key={index} value={person.id}>{person.code}</option>
                )}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="id_statut_absence">Statut Absence</label>
              <select name="id_statut_absence" id="id_statut_absence" onChange={handleStatutChange} required>
                <option value={1}>Congé</option>
                <option value={2}>Maladie</option>
                <option value={3}>Mission</option>
              </select>
            </div>

            {statutAbsence === 3 && (
              <div className="form-group">
                <label htmlFor="lieu">Lieu</label>
                <input type="text" name="lieu" id="lieu" />
              </div>
            )}

            <div className="btn-container">
              <button type="submit">Ajouter</button>
              <button type="button" onClick={handleCloseAddModal}>Annuler</button>
            </div>
          </form>
        </Box>
      </Modal>
    </div>
  );
}

export default AbsencePersonnel;
